<script lang="ts" setup>
// import { ToastProvider } from 'reka-ui'
import { ToastAction, ToastDescription, ToastProvider, ToastRoot, ToastTitle, ToastViewport } from 'reka-ui'
import ToastMessage from '@/components/ToastMessage.vue'
import useToasts from '@/composables/useToasts'
import { ref } from 'vue'

const { toasts, removeToast } = useToasts()

function toastClosed(id: symbol) {
  setTimeout(() => {
    removeToast(id)
  }, 500) // Delay to allow closing animation to finish
}

const open = ref(true)
</script>

<template>
  <ToastProvider>
    <slot></slot>
    <ToastMessage v-for="toast in toasts" :key="toast.id" :duration="toast.duration" @update:open="() => toastClosed(toast.id)">
      <template #title>
        {{ toast.title }}
      </template>
      {{ toast.message }}
      <template #icon>
        <component :is="toast.icon" />
      </template>
    </ToastMessage>
    <ToastViewport class="toast-viewport" />
  </ToastProvider>
</template>

<style lang="scss">
.toast-viewport {
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 469px;
  max-width: calc(100vw - 16px);
  list-style: none;
  z-index: 2147483647;
  outline: none;
  position: fixed;
  top: 52px;
  right: 0;
  margin: 0;
}
</style>
